import { useQuery } from "@tanstack/react-query"
import { getWorkforceAnalytics } from "../actions/getWorkforceAnalytics.action"
import { ETimePeriods } from "../enums/timesheets.enum"


export const useGetWorkforceAnalaytics = (period: ETimePeriods) => {
    return useQuery({
        queryKey: ["workforce-analytics", period],
        queryFn: () => getWorkforceAnalytics(period),
    })
}